import { Stack } from "expo-router";
import { useThemeColors } from "@/providers/ThemeProvider";

export default function ChallengeLayout() {
  const colors = useThemeColors();

  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: colors.background },
      }}
    >
      <Stack.Screen name="[id]" />
    </Stack>
  );
}

